import React from "react"

import Flex from "@irati/ui/src/Flex"
import {Body, H4} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import {UserRedemptionReportSavingsDataBreakdown, UserRedemptionReportSavingsDataBreakdownType} from "@irati/types"

import {DiscountIcon, FlexiPointsIcon, FlexiRewardsIcon, GiftCardsIcon} from "./MySavingsCard/Icons"

interface Props {
  breakdown?: UserRedemptionReportSavingsDataBreakdown[]
}

const BreakdownDetails = ({breakdown = []}: Props) => {
  return (
    <>
      {breakdown.map((b, i) => (
        <Flex alignItems="center" marginTop={!i && 2} key={`estimatedBreakdown${i}`} gap={1}>
          {getTypeIcon(b.type)}
          <H4 as="span">
            <FormattedCurrency value={b.value} currency={b.currency} />
          </H4>
          <Body small>{getBreakdownLabel(b.type)}</Body>
        </Flex>
      ))}
    </>
  )
}

export default BreakdownDetails


const getBreakdownLabel = (breakdownType: UserRedemptionReportSavingsDataBreakdownType) => {
  switch (breakdownType) {
    case UserRedemptionReportSavingsDataBreakdownType.FlexiPerks:
      return <FormattedMessage id="platform.mySavings.breakdown.tooltip.flexiPerks" />
    case UserRedemptionReportSavingsDataBreakdownType.FlexiRewards:
      return <FormattedMessage id="platform.mySavings.breakdown.tooltip.flexiRewards" />
    case UserRedemptionReportSavingsDataBreakdownType.GiftCards:
      return <FormattedMessage id="platform.mySavings.breakdown.tooltip.giftCards" />
    case UserRedemptionReportSavingsDataBreakdownType.DiscountCodes:
      return <FormattedMessage id="platform.mySavings.breakdown.tooltip.discountCodes" />
    default:
      return null
  }
}
export const getTypeIcon = (breakdownType: string) => {
  switch (breakdownType) {
    case UserRedemptionReportSavingsDataBreakdownType.FlexiPerks:
    case "flexi_perk":
      return <FlexiPointsIcon />
    case UserRedemptionReportSavingsDataBreakdownType.FlexiRewards:
    case "reward":
      return <FlexiRewardsIcon />
    case UserRedemptionReportSavingsDataBreakdownType.DiscountCodes:
    case "% discount voucher":
      return <DiscountIcon />
    default:
      return <GiftCardsIcon />
  }
}
export const getTypeLabel = (breakdownType: UserRedemptionReportSavingsDataBreakdownType) => {
  switch (breakdownType) {
    case UserRedemptionReportSavingsDataBreakdownType.FlexiPerks:
      return <FormattedMessage id="platform.mySavings.type.flexiPerks.label" />
    case UserRedemptionReportSavingsDataBreakdownType.FlexiRewards:
      return <FormattedMessage id="platform.mySavings.type.flexiRewards.label" />
    case UserRedemptionReportSavingsDataBreakdownType.GiftCards:
      return <FormattedMessage id="platform.mySavings.type.giftCards.label" />
    case UserRedemptionReportSavingsDataBreakdownType.DiscountCodes:
      return <FormattedMessage id="platform.mySavings.type.discountCodes.label" />
    default:
      return null
  }
}
